import React, { useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-modal';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

// Image Imports
import Startimg from '../../images/affiliate/star.png';
import Line from '../../images/affiliate/headingline.png';
import BackgImage from '../../images/affiliate/home.png';
import logo1 from '../../images/affiliate/logo1.png';
import logo2 from '../../images/affiliate/logo2.png';
import logo3 from '../../images/affiliate/logo3.png';
import logo4 from '../../images/affiliate/logo4.png';
import logo5 from '../../images/affiliate/logo5.png';
import logo6 from '../../images/affiliate/logo6.png';
import Settingimag from '../../images/affiliate/Frame4.png';
import icon1 from '../../images/affiliate/icon1.png';
import icon2 from '../../images/affiliate/icon2.png';
import icon3 from '../../images/affiliate/icon3.png';
import icon4 from '../../images/affiliate/icon4.png';
import post1 from '../../images/affiliate/Frame3.png';
import post2 from '../../images/affiliate/Frame2.png';
import post3 from '../../images/affiliate/Frame1.png';
import tstimonialogo from '../../images/affiliate/copnylogo2.png';
import tstimonialogo1 from '../../images/affiliate/copnylogo1.png';
import tstimonialogo2 from '../../images/affiliate/copnylogo.png';
import Author1 from '../../images/affiliate/author1.png';
import Author2 from '../../images/affiliate/author2.png';
import Author3 from '../../images/affiliate/author3.png';
import Iconbx1 from '../../images/affiliate/icon8.png';
import Iconbx2 from '../../images/affiliate/icon5.png';
import Iconbx3 from '../../images/affiliate/icon6.png';
import Iconbx4 from '../../images/affiliate/icon7.png';

import './affiliate.css';

const PageContainers = styled.div`
  p{
    color: #5B5B5B !important;
    font-weight: 500 !important ;
  }

`;

const Hero = styled.div`
  background-image: linear-gradient(180deg, #4F46E5, #2C277F);
  height: 800px;
  @media screen and (min-width: 701px) and (max-width: 1100px) {
  height: 100%;
  }
`;

const CarouselWrapper = styled.div`
  overflow: hidden;
  width: 100%;
  border-bottom: 1px solid #E2E2E2;
`;

const LogoCarousel = styled.div`
  padding: 4rem 0rem;
  overflow: hidden;

  h2 {
    text-align: center;
    font-size: 40px;
    margin-bottom: 2rem;
    line-height: 48px;
    font-family: BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif;
    color: #000;
    font-weight: 600;

    @media (max-width: 768px) {
      padding: 10px;
      font-size: 24px;
      line-height: 30px;
    }
  }

  span {
    color: #4F46E5;
  }
`;

const CarouselTrack = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
  width: fit-content;
  animation: scroll 25s linear infinite;
  padding: 50px;

  img {
    height: auto;
    margin-right: 7rem;
    opacity: 0.8;
    transition: all 0.3s ease;

    &:hover {
      filter: none;
      opacity: 1;
    }
  }

  @keyframes scroll {
    0% {
      transform: translateX(0%);
    }
    100% {
      transform: translateX(-50%);
    }
  }
`;

const FAQsection = styled.div`
  padding: 3em 8em;
  @media screen and (max-width: 700px) {
  padding: 1em;
  }
@media screen and (min-width: 701px) and (max-width: 1100px) {
    padding: 3em 5em;
}
  h2{
  padding: 1em 0;
  }

  p{
  text-align: center;
  }

`;
const FaqItem = styled.div`
 padding: 5em  0 0 0;
`;
const AccordionItems = styled.div`
  border-bottom: 1px solid #E2E2E2;
  padding-bottom: 1em;
`;
const Question = styled.div``;
const Answer = styled.div`
  padding-bottom: 1em;
`;
const Iconbox = [
  {
    Iconboxtitle: "30% Recurring Commissions",
    Iconboxdesc: "Earn a share of every subscription, every month, for as long as your referral stays with us.",
    Iconboximg: icon1,
  },
  {
    Iconboxtitle: "Easy Tracking Dashboard",
    Iconboxdesc: "You’ll have access to a clean, simple dashboard to see your clicks, signups, and earnings.",
    Iconboximg: icon2,
  },
  {
    Iconboxtitle: "90-Days Cookie Window",
    Iconboxdesc: "If someone signs up within 90 days of clicking your link, you still get credit.",
    Iconboximg: icon3,
  },
  {
    Iconboxtitle: "Reliable Monthly Payouts",
    Iconboxdesc: "We send out payments like clockwork. No delays, no guesswork.",
    Iconboximg: icon4,
  },
];

const Simplebx = [
  {
    SimplebxImage: post1,
    SimplebxTitle: "Sign Up",
    SimplebxDesc: "Create your affiliate account and get your unique referral link in minutes.",
  },
  {
    SimplebxImage: post2,
    SimplebxTitle: "Share Your Link",
    SimplebxDesc: "Promote ServTrackr through your blog, videos, email list, or social media.",
  },
  {
    SimplebxImage: post3,
    SimplebxTitle: "Get Paid",
    SimplebxDesc: "Earn recurring commissions for every subscription made through your link.",
  },
];

const plan = [
  {
    planType: "Monthly Plans",
    plancommission: "30% every month",
    paymentType: ["Recurring"],
  },
  {
    planType: "Annual Plans",
    plancommission: "30% one-time",
    paymentType: ["Upfront payout"],
  },
];

const testimonials = [
  {
    company: 'Company',
    logo: tstimonialogo,
    rating: 5,
    text: `I've tested a few affiliate programs, but ServTrackr is the one that keeps delivering. It converts well, and payments are always on time.`,
    author: 'Tech Blogger',
    authornmae:'Jason L.',
    avatar: Author1,
    bgColor: '#F8DDEB',
  },
  {
    company: 'Company',
    logo: tstimonialogo1,
    rating: 5,
    text: `The dashboard is easy to use, and their support team is quick to help. I made my first referral in less than two weeks.`,
    author: 'Content Creator',
    authornmae:'Riya P.',
    avatar: Author2,
    bgColor: '#D3EDF9',
  },
  {
    company: 'Zigs',
    logo: tstimonialogo2,
    rating: 5,
    text: `I've tested a few affiliate programs, but ServTrackr is the one that keeps delivering. It converts well, and payments are always on time.`,
    author: 'Senior Affiliate Coordinator',
    authornmae:'Mike Warren',
    avatar: Author3,
    bgColor: '#FBE9DA',
  },
];

const footerfaqs = [
  {
    question: "How do payouts work?",
    answer: "We process payments monthly via PayPal or bank transfer. Minimum payout is $50."
  },
  {
    question: "Can I join from outside the United States?",
    answer: "We process payments monthly via PayPal or bank transfer. Minimum payout is $50.Absolutely. ServTrackr is designed to scale with you. Whether you're a solo contractor just starting out or a growing team handling multiple jobs a day, our HVAC software for small businesses gives you the flexibility, simplicity, and power to grow without getting overwhelmed."
  },
  {
    question: "How long does the cookie last?",
    answer: "We process payments monthly via PayPal or bank transfer. Minimum payout is $50."
  },
  {
    question: "What platform is this built on?",
    answer: "We process payments monthly via PayPal or bank transfer. Minimum payout is $50."
  }
];

const iconbx = [
{
  iconbximg:Iconbx1,
  iconboxtitle:"Transparent Terms",
  icondesc:"Clear affiliate agreement with no hidden clauses",
},
{
  iconbximg:Iconbx2,
  iconboxtitle:"GDPR Compliant",
  icondesc:"Full compliance with data protection regulations",
},
{
  iconbximg:Iconbx3,
  iconboxtitle:"Dedicated Support",
  icondesc:"affiliates@servtrackr.com for any questions",
},
{
  iconbximg:Iconbx4,
  iconboxtitle:"Trusted Platform",
  icondesc:"Affiliate platform powered by FirstPromoter",
}
];

const Affiliate = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const [activeIndex, setActiveIndex] = React.useState(0);
  
  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  autoplay: true,
  responsive: [
    {
      breakpoint: 1024, // tablets and below
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 768, // mobile devices
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

  return (
    <PageContainers>
      <Hero>
        <div className="hero-section">
          <div className="hero-box">
            <button className="design-bx">
              <img src={Startimg} alt="Star" /> Your Affiliate Partner
            </button>
            <h2>
              Earn <span style={{
                       backgroundImage: `url(${Line})`,
                        backgroundRepeat: 'no-repeat',
                       backgroundPosition: 'bottom',
                        backgroundSize: 'contain',
                      overflow: 'hidden',}}>30% Recurring </span><br /> Commission Every Month.
            </h2>
            <p>
              Love recommending great tools? Promote ServTrackr, the go-to software for field service businesses,
              and get paid monthly for every referral who signs up.
            </p>
            <div className="button">
              <button onClick={() => navigate('/free-trial')}>Become an Affiliate</button>
              <button className="play-btn" onClick={openModal}>▶</button>
            </div>

            {/* ✅ Modal code */}
            <Modal
              isOpen={isModalOpen}
              onRequestClose={closeModal}
              contentLabel="Video Modal"
              className="modal"
              overlayClassName="overlay"
              ariaHideApp={false} // optional: to avoid warnings
            >
              <button onClick={closeModal} className="close-btn">✖</button>
              <iframe
                width="100%"
                height="400"
                src="https://www.youtube.com/embed/dQw4w9WgXcQ"
                title="Demo Video"
                frameBorder="0"
                allowFullScreen
              ></iframe>
            </Modal>
          </div>
          <div className="hero-box">
            <img class="hero-img" src={BackgImage} alt="Star" />
          </div>
        </div>
      </Hero>

      <LogoCarousel>
              <h2>More Than 5,000 Companies Trust Us <br></br>And Collaborate With Us</h2>
              <CarouselWrapper>
                <CarouselTrack>
                  {/* Duplicate logos to loop perfectly */}
                  {[logo1, logo2, logo3, logo1, logo2, logo3, logo1, logo2, logo3].map((logo, i) => (
                    <img src={logo} alt={`Client ${i}`} key={i} />
                  ))}
                  {[logo1, logo2, logo3, logo1, logo2, logo3, logo1, logo2, logo3].map((logo, i) => (
                    <img src={logo} alt={`Client ${i + 6}`} key={i + 6} />
                  ))}
                </CarouselTrack>
              </CarouselWrapper>
        </LogoCarousel>
      
      <div className="third-sc">
          <h2>Why People Love Promoting<br /> ServTrackr</h2>
          <p>Here's what makes our affiliate program worth your while:</p>

          <div className="flx-sc">
            <div className="frst-sc">
              <img class="img-frst" src={Settingimag} alt="Settings" />
            </div>

            <div className="frst-sc">
              {Iconbox.map((item, index) => (
                <div key={index} class="icon-bx">
                  <div class="inricn-bx">
                  <img src={item.Iconboximg} alt={`Icon ${index + 1}`} />
                  </div>
                  <div class="inricn-bxs">
                  <h3>{item.Iconboxtitle}</h3>
                  <p>{item.Iconboxdesc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div class="simple-sc">
          <h2>Getting Started is Simple</h2>
          <p>You don’t need a big audience or marketing experience. Just follow these steps:</p>
            
            <div class="simple-bxs">
              {Simplebx.map((simple, index) => (
                <div class="simple-bx" key={index}>
                  <div class="featured-img">
                   <img src={simple.SimplebxImage} alt={simple.SimplebxTitle} />
                  </div>
                  <div class="post-cont">
                    <div class="count-no">
                      <span>{(index + 1).toString().padStart(2, '0')}</span>
                    </div>
                    <div class="box-desc">
                      <h3>{simple.SimplebxTitle}</h3>
                      <p>{simple.SimplebxDesc}</p>
                    </div>
                  </div>
                  </div>

              ))}
            </div>
        </div>
        

      <div class="earn-div">
          <h2>What You Will Earn</h2>

          <div class="pln-mnbx">
            <div class="pln-hdr">
              <div class="pln-clmn">
                <h3>Plan Type</h3>
              </div>
              <div class="pln-clmn">
              <h3>Commission</h3>
              </div>
              <div class="pln-clmn">
              <h3>Payment Type</h3>
              </div>
            </div>

             <div className="plan-cnt">
              {plan.map((plan, index) => (
                <div className="pln-bxs" key={index}>
                  <div className="pmt-typ">
                    <p className="pln-tp">{plan.planType}</p>
                  </div>
                  <div className="pmt-typ">
                    <p className="plncmm">{plan.plancommission}</p>
                  </div>
                  <div className="pmt-typ">
                    {plan.paymentType.map((type, i) => (
                      <p
                        key={i}
                        className={`plntyp ${
                          type === "Recurring"
                            ? "recurring-text"
                            : type === "Upfront payout"
                            ? "upfront-text"
                            : ""
                        }`}
                      >
                        {type}
                      </p>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
      </div>

        <div class="earn-sc">
            <div class="earn-bx">
              <h2>Example Earnings:</h2>
              <p>Refer five people on our $99/month plan and you’ll make $148.50 every month, over $1,700 per year in passive income.</p>
            </div>
        </div>


        <section className="py-16 bg-white">
          <div class="tst-tlt">
            <h2>What Our Affiliates Say</h2>
            <p>Hear from our valued affiliates who’ve experienced real growth, strengthened partnerships, and achieved success through our collaborative program.</p>
          </div>
            <div className="max-w-3xl mx-auto px-4">
              <Slider {...settings}>
                {testimonials.map((t, i) => (
                  <div key={i} className="p-4">
                    <div
                      className="rounded-3xl p-6 flex flex-col items-center shadow-md"
                      style={{ backgroundColor: t.bgColor }}
                    >
                      <div class="img-bx">
                      <img src={t.logo} alt={t.company} className="h-8 mb-3" />
                      <div className="flex text-yellow-500 mb-4 text-lg">
                        {'★'.repeat(t.rating)}
                      </div>
                      </div>
                      <div className="bg-[#3E37B5] text-white rounded-xl p-6 text-center relative w-full">
                        <p className="text-sm leading-relaxed">{t.text}</p>
                        <div className="absolute left-1/2 transform -translate-x-1/2 bottom-[-16px] w-4 h-4 bg-[#4026B7] rotate-45"></div>
                      </div>
                      <div className="mt-6 flex items-center gap-3">
                        <img src={t.avatar} alt={t.author} className="w-10 h-10 rounded-full" />
                        <div class="avatar-bx">
                          <h4>{t.authornmae}</h4>
                          <p className="text-sm text-gray-600">{t.author}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </section>

        <div class="counter-sect">
              <h2>Ready to Start Earning?</h2>
              <p class="wht-txt">It’s free to join, takes under two minutes to sign up, and you can start earning right away.</p>
              <button>Become an Affiliate</button>
            <div class="counter-bx">
              <div class="inr-countr">
              <h3>$50K+</h3>
              <p class="wht-txt">Paid to affiliates this month</p>
              </div>
              <div class="inr-countr">
              <h3>500+</h3>
              <p class="wht-txt">Active affiliates</p>
              </div>
              <div class="inr-countr">
              <h3>95%</h3>
              <p class="wht-txt">Customer retention rate</p>
              </div>
            </div>
        </div>

        <FAQsection>
            <h2>Frequently Asked Questions</h2>
              <p>Find quick answers to common questions about our services, features, and how to get started.</p>
               
              <FaqItem>
              {footerfaqs.map((item, index) => {
               const isActive = activeIndex === index;
                  return (
                    <AccordionItems key={index}>
                      <Question
                      onClick={() => toggleAccordion(index)}
                      style={{
                        backgroundColor: isActive ? '#fff' : 'transparent',
                        color: isActive ? '#000' : '#000',
                       padding: '1rem',
                        borderRadius: '8px 8px 0 0',
                        cursor: 'pointer',
                        marginBottom: '10px',
                        transition: 'all 0.3s ease',
                        margin: '0px',
                        fontSize: '20px',
                        fontFamily: 'BlinkMacSystemFont, sans-serif !important',
                        fontWeight: '600',
                        }}
                            >
                              {item.question}
                              <span style={{ float: 'right' }}>{isActive ? '-' : '+'}</span>
                            </Question>
        
                            {isActive && (
                              <Answer
                                dangerouslySetInnerHTML={{ __html: item.answer }}
                                style={{
                                  backgroundColor: '#fff',
                                  padding: '0 1em',
                                  borderRadius: '0 0 8px 8px',
                                  color: '#000',
                                  fontSize: '15px',
                                  margin: '0px',
                                }}
                              />
                            )}
                          </AccordionItems>
                        );
                      })}
                  </FaqItem>
        
                  </FAQsection>

          
           <div class="icon-bxs">
              {iconbx.map((icnbx, index) => (
                <div class="ftricn-bx" key={index}>
                  <div class="ftr-bxs">
                   <img src={icnbx.iconbximg} alt={icnbx.SimplebxTitle} />
                    <h3>{icnbx.iconboxtitle}</h3>
                      <p>{icnbx.icondesc}</p>
                  </div>
                  </div>

              ))}
            </div>
    </PageContainers>
  );
};

export default Affiliate;
